import styled from 'styled-components';
import { themeColor } from '@hud/web-components/theme/colors';
import { baseFont, smRegular } from '@hud/web-components/theme/typography';
import { Button } from '@hud/web-components/Button/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  color: ${themeColor('textPrimary')};
`;

export const Title = styled.div`
  ${baseFont};
  font-weight: 600;
  font-size: 30px;
`;

export const ApiKeysContainer = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: center;
  min-height: 100px;
`;

export const Description = styled.p`
  ${smRegular}

  a {
    color: #0ffbe4;
    text-decoration: none;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 40px;
  margin-left: 40px;
  text-decoration: none;
`;
